import { fg } from '@atlassian/jira-feature-gating';

const JscM2FeChangesRelayProvider = {
	get(): boolean {
		return fg('jsc_m2_hierarchy_fe_changes');
	},
};

export default JscM2FeChangesRelayProvider;
